import { useState, useEffect } from "react";
import { AdminLayout } from "./Dashboard";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import axios from "axios";
import { format, parseISO } from "date-fns";
import { es } from "date-fns/locale";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminSessions() {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSessions();
  }, []);

  const fetchSessions = async () => {
    try {
      const response = await axios.get(`${API}/admin/sessions`);
      // Handle both old array response and new paginated response
      const data = response.data;
      setSessions(Array.isArray(data) ? data : data.sessions || []);
    } catch (error) {
      console.error("Error fetching sessions:", error);
    } finally {
      setLoading(false);
    }
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case 'confirmed':
        return <span className="badge-approved">Confirmada</span>;
      case 'cancelled':
        return <span className="badge-rejected">Cancelada</span>;
      case 'completed':
        return <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium">Completada</span>;
      default:
        return <span className="badge-pending">{status}</span>;
    }
  };

  return (
    <AdminLayout title="Sesiones">
      <div className="bg-white rounded-2xl border border-stone-200 overflow-hidden">
        {loading ? (
          <div className="flex justify-center py-12">
            <div className="spinner"></div>
          </div>
        ) : sessions.length === 0 ? (
          <div className="text-center py-12">
            <p className="text-stone-600">No hay sesiones registradas</p>
          </div>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Usuario</TableHead>
                <TableHead>Listener</TableHead>
                <TableHead>Fecha</TableHead>
                <TableHead>Hora</TableHead>
                <TableHead>Precio</TableHead>
                <TableHead>Estado</TableHead>
                <TableHead>Pago</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {sessions.map((session) => (
                <TableRow key={session.id} data-testid={`session-row-${session.id}`}>
                  <TableCell className="font-medium">{session.user_name}</TableCell>
                  <TableCell>{session.listener_name}</TableCell>
                  <TableCell>
                    {format(parseISO(session.date), "d MMM yyyy", { locale: es })}
                  </TableCell>
                  <TableCell>{session.time}</TableCell>
                  <TableCell>${session.price}</TableCell>
                  <TableCell>{getStatusBadge(session.status)}</TableCell>
                  <TableCell>
                    <span className={session.payment_status === 'completed' ? 'text-green-600' : 'text-amber-600'}>
                      {session.payment_status === 'completed' ? 'Pagado' : 'Pendiente'}
                    </span>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </div>
    </AdminLayout>
  );
}
